import React from "react";

import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";

import Swipper from "../../Swipper/Swipper";
import Styles from "./LorryBookingSteps.module.scss";
import useHomepageV2Translation from "../hooks/useHomepageV2Translation";
import AppImg from "../../utils/AppImg";
import HomepageV2Animate from "../animate/HomepageV2Animate";

const STEP_NUMBERS = ["01", "02", "03", "04"];

const STEP_ICONS = [
    "/homepage-v2/booking-step-11.png",
    "/homepage-v2/booking-step-12.png",
    "/homepage-v2/booking-step-13.png",
    "/homepage-v2/booking-step-14.png"
] as const;

const LorryBookingSteps = () => {
    const { t } = useHomepageV2Translation();
    const isMobileScreen = useMediaQuery({ queryType: "mobile" });
    const stepsRaw = t("homepageV2:bookingSteps.steps", { returnObjects: true });
    const steps = (Array.isArray(stepsRaw) ? stepsRaw : []) as Array<{
        title: string;
        description: string;
    }>;

    if (!steps.length) {
        return null;
    }

    const renderStep = (step: { title: string; description: string }, index: number) => (
        <div className={Styles.step}>
            <div className={Styles.stepHead}>
                <div className={Styles.iconWrap}>
                    <AppImg src={STEP_ICONS[index]} alt={step.title} width={24} height={24} unoptimized />
                </div>
                <p className={Styles.stepNumber} aria-hidden="true">
                    {STEP_NUMBERS[index]}
                </p>
            </div>
            <h3 className={Styles.stepTitle}>{step.title}</h3>
            <p className={Styles.stepDescription}>{step.description}</p>
        </div>
    );

    return (
        <div className={Styles.container}>
            <HomepageV2Animate variant="fade-up" className={Styles.header}>
                <p className={Styles.eyebrow}>{t("homepageV2:bookingSteps.eyebrow")}</p>
                <h2 className={Styles.title}>
                    <span className={Styles.titleLine}>{t("homepageV2:bookingSteps.title")}</span>
                    <span className={Styles.titleHighlight}>{t("homepageV2:bookingSteps.titleHighlight")}</span>
                </h2>
            </HomepageV2Animate>

            {isMobileScreen ? (
                <Swipper
                    className={Styles.stepsSwiper}
                    cssMode={false}
                    slidesPerView={1}
                    spaceBetween={16}
                    pagination
                    navigation={false}
                    mousewheel={false}
                    keyboard={false}
                    autoplay={{ delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                    list={steps.map((step, index) => ({
                        key: STEP_NUMBERS[index],
                        node: renderStep(step, index)
                    }))}
                />
            ) : (
                <div className={Styles.grid}>
                    {steps.map((step, index) => (
                        <HomepageV2Animate key={STEP_NUMBERS[index]} variant="fade-up" delay={index * 110}>
                            {renderStep(step, index)}
                        </HomepageV2Animate>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LorryBookingSteps;
